var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscoverLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 32,
    viewBox: "0 0 50 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 32,
    rx: 3,
    fill: "#231F20"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.72173 12.9725H6V18.9856H7.71261C8.62327 18.9856 9.28087 18.7708 9.85808 18.2914C10.544 17.7238 10.9497 16.8682 10.9497 15.9832C10.9499 14.2088 9.62393 12.9725 7.72173 12.9725ZM9.09195 17.4897C8.72335 17.8225 8.24477 17.9676 7.48691 17.9676H7.17218V13.9914H7.48691C8.24477 13.9914 8.70462 14.1269 9.09195 14.4776C9.49763 14.8387 9.74158 15.3986 9.74158 15.9744C9.74158 16.5518 9.49763 17.1287 9.09195 17.4897Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6625 12.9725H11.4895V18.9856H12.6625V12.9725Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5305 15.2801C14.8267 15.0197 14.62 14.8479 14.62 14.5231C14.62 14.1442 14.9882 13.8565 15.4937 13.8565C15.8452 13.8565 16.1339 14.0009 16.4395 14.3435L17.0532 13.5399C16.5489 13.0987 15.9455 12.8732 15.2862 12.8732C14.2223 12.8732 13.4107 13.612 13.4107 14.5962C13.4107 15.4246 13.7886 15.8487 14.8902 16.2451C15.3494 16.407 15.5831 16.5149 15.701 16.5875C15.9354 16.7405 16.0527 16.9572 16.0527 17.2096C16.0527 17.6968 15.6654 18.0578 15.1421 18.0578C14.5826 18.0578 14.132 17.778 13.862 17.2558L13.1044 17.9855C13.6448 18.7788 14.2937 19.1304 15.1863 19.1304C16.4051 19.1304 17.2602 18.32 17.2602 17.1559C17.26 16.2005 16.8648 15.768 15.5305 15.2801Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6301 15.9832C17.6301 17.7507 19.0181 19.1212 20.8041 19.1212C21.3091 19.1212 21.7415 19.0219 22.2747 18.7708V17.3901C21.8057 17.8595 21.3904 18.0487 20.8587 18.0487C19.6774 18.0487 18.8391 17.1922 18.8391 15.9745C18.8391 14.8201 19.704 13.9092 20.8043 13.9092C21.3637 13.9092 21.7872 14.1089 22.2749 14.5858V13.2057C21.76 12.9445 21.3367 12.8363 20.832 12.8363C19.0546 12.8366 17.6301 14.235 17.6301 15.9832Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5744 17.0115L29.9708 12.9725H28.6895L31.2415 19.14H31.8726L34.4703 12.9725H33.1988L31.5744 17.0115Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0006 18.9856H38.327V17.9678H36.1726V16.3447H38.2476V15.3261H36.1726V13.9914H38.327V12.9725H35.0006V18.9856Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.971 14.7477C42.971 13.6219 42.1956 12.9725 40.8429 12.9725H39.1038V18.9856H40.2753V16.5701H40.4283L42.0517 18.9857H43.4942L41.6013 16.4523C42.4846 16.2727 42.971 15.6684 42.971 14.7477ZM40.618 15.7409H40.2754V13.9196H40.6365C41.367 13.9196 41.7642 14.2257 41.7642 14.8109C41.7642 15.4155 41.3671 15.7409 40.618 15.7409Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8564 19.1988C27.6231 19.1988 29.0553 17.7667 29.0553 16C29.0553 14.2333 27.6231 12.8011 25.8564 12.8011C24.0898 12.8011 22.6576 14.2333 22.6576 16C22.6576 17.7667 24.0898 19.1988 25.8564 19.1988Z",
    fill: "url(#paint0_linear_117_726)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M25.8564 19.1988C27.6231 19.1988 29.0553 17.7667 29.0553 16C29.0553 14.2333 27.6231 12.8011 25.8564 12.8011C24.0898 12.8011 22.6576 14.2333 22.6576 16C22.6576 17.7667 24.0898 19.1988 25.8564 19.1988Z",
    fill: "url(#paint1_linear_117_726)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7197 13.1985C43.7197 13.093 43.6471 13.0354 43.5196 13.0354H43.3499V13.5639H43.476V13.3589L43.6239 13.5639H43.7778L43.604 13.346C43.6787 13.326 43.7197 13.2719 43.7197 13.1985ZM43.4974 13.2707H43.4761V13.1325H43.4987C43.561 13.1325 43.5936 13.155 43.5936 13.2005C43.5936 13.2471 43.5607 13.2707 43.4974 13.2707Z",
    fill: "#231F20"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5452 12.8381C43.2885 12.8381 43.0848 13.0429 43.0848 13.2988C43.0848 13.5547 43.2908 13.7597 43.5452 13.7597C43.7952 13.7597 44 13.5524 44 13.2988C44 13.0463 43.7951 12.8381 43.5452 12.8381ZM43.5431 13.6773C43.3412 13.6773 43.176 13.5092 43.176 13.2995C43.176 13.0891 43.3391 12.9211 43.5431 12.9211C43.7442 12.9211 43.908 13.0929 43.908 13.2995C43.908 13.5074 43.7444 13.6773 43.5431 13.6773Z",
    fill: "#231F20"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_117_726",
    x1: 27.4938,
    y1: 18.5636,
    x2: 25.2789,
    y2: 15.0958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89F21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2502,
    stopColor: "#F79A23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5331,
    stopColor: "#F78E22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6196,
    stopColor: "#F68721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7232,
    stopColor: "#F48220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F27623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_117_726",
    x1: 27.1439,
    y1: 18.5165,
    x2: 23.9069,
    y2: 12.1894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68721",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3587,
    stopColor: "#E27027",
    stopOpacity: 0.2704
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#D4612C",
    stopOpacity: 0.5299
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#D15D2D",
    stopOpacity: 0.74
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverLogo);
export default __webpack_public_path__ + "static/media/discover-logo.ba91248bbd8222e90c58b808952a7e66.svg";
export { ForwardRef as ReactComponent };